import { Injectable } from '@angular/core';
import { BaseService } from '../shared/services/base.service';
import { AlertsService } from './alerts.service';
import { LoaderService } from './loader.service';
import { DateFormatPipe } from '../pipes/date-format.pipe';
import { UtilService } from './util.service';
@Injectable()
export class exportImportFilesService {
    constructor(
        public baseService: BaseService,
        public alerts: AlertsService,
        public loader: LoaderService,
        public datePipe:DateFormatPipe,
        public utilService: UtilService
    ) {

    }
    setUserInfo(userInfo,isBannerReq){
        let  str = "";
        if(userInfo && isBannerReq){
                if(typeof userInfo == "object"){
                  //'Name,Sanjeev'+'\r\n' + 'Name,Sanjeev'+'\r\n' + 'Name,Sanjeev' + '\r\n' +'Name,Sanjeev'
                    // for (const [key, value] of Object.entries(userInfo)) {
                    //    // console.log(`${key}: ${value}`);
                    //     str += `Order ID,${userInfo['orderId']}`,`UHID,${userInfo['uhId']}`,`Patient Name,${userInfo['patient_name']}`,
                    //     `Patient Age,${userInfo['patient_age']}`,`Mobile,${userInfo['telecom']}`,`Ward No,${userInfo['wardNo']}`;
                    //   }
                      str += `Order ID,${userInfo['orderId']},UHID,${userInfo['uhId']},Patient Name,${userInfo['patient_name']},
                      Patient Age,${userInfo['patient_age']},Mobile,${userInfo['telecom']},Ward No,${userInfo['wardNo']},
                      Admission Id,${userInfo['admissionId']}`+'\r\n';
                }
        } 
        return str+ '\r\n' +'\r\n' + `, , ------------------------Item Details---------------------`+'\r\n';
    } 
    downloadFile(data, filename = 'data', headers,userInfo?,isBannerReq?) {
        let csvData = this.ConvertToCSV(data, headers,userInfo,isBannerReq);
        // console.table(data);
        let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
            dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", filename + ".csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    ConvertToCSV(objArray, headerList,userInfo,isBannerReq) {
        var datePipeString;
        let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
        let row = 'S.No,';
        for (let index in headerList) {
            const col = headerList[index];
            row += (col && typeof col === 'object' ? col.label : col) + ',';
        }
        row = row.slice(0, -1); 
        str = this.setUserInfo(userInfo,isBannerReq);
        str += row + '\r\n';
        for (let i = 0; i < array.length; i++) {  
            let line = (i + 1) + '';
            for (let index in headerList) {
                const col = headerList[index];
                const key = col && typeof col === 'object' ? col.key : col;
                const fieldType = (col && typeof col === 'object' ? (col.type || '') : '').toLowerCase();
                const dbData = array[i][key];
                switch (fieldType) {
                    case 'date':
                        datePipeString = dbData ? this.datePipe.transform(dbData) : '';
                        line += ',' + this.escapeCsvValue(datePipeString === 'Invalid Date' ? '' : datePipeString);
                        break;
                    case 'datetime':
                        datePipeString = dbData ? this.utilService.toTimeZoneDateFormat(dbData, 'datetime') : '';
                        line += ',' + this.escapeCsvValue(datePipeString === 'Invalid Date' ? '' : datePipeString);
                        break;
                    case 'time':
                        datePipeString = dbData ? this.utilService.toTimeZoneDateFormat(dbData, 'time') : '';
                        line += ',' + this.escapeCsvValue(datePipeString === 'Invalid Date' ? '' : datePipeString);
                        break;
                    case 'monthYear':
                        datePipeString = dbData ? this.utilService.toTimeZoneDateFormat(dbData, 'monthYear') : '';
                        line += ',' + this.escapeCsvValue(datePipeString === 'Invalid Date' ? '' : datePipeString);
                        break;
                    default:
                        line += ',' + this.escapeCsvValue(dbData);
                        break;
                }
            }
            str += line + '\r\n';
        }
        return str;
    }

    private escapeCsvValue(value: any): string {
        if (value === null || value === undefined) {
            return '';
        }
        let strValue = String(value).trim();
        if (strValue.includes(',') || strValue.includes('"') || strValue.includes('\n')) {
            strValue = strValue.replace(/"/g, '""');
            return `"${strValue}"`;
        }
        return strValue;
    }

    handleFileReponse(fileObj, action, fileData, callback = null) {
        var fileName = "";
        var fileResponse: any = "";
        if (fileObj.contentType != 'byte_array') {
            fileName = fileObj.key + '.' + fileObj.contentType;
            fileObj.contentType = "application/" + fileObj.contentType;//TODO (we have to get from mapping)
            fileResponse = fileData
        } else {

            fileName = (fileData.documentName != undefined) ? fileData.documentName : fileObj.key;
            fileObj.contentType = (fileData.documentContentType != undefined) ? fileData.documentContentType : fileObj.contentType;
            if (fileData.inputStream != undefined && fileData.inputStream.length > 0) {
                var fileData = fileData.inputStream;
                fileResponse = new Uint8Array(fileData.length);
                for (let i = 0; i < fileResponse.length; i++) {
                    fileResponse[i] = fileData[i];
                }
            } else {
                this.alerts.error('File Data not found');
                this.loader.hideSpinner();
                if (callback) {
                    callback(false);
                }
                return;
            }
        }
        switch (action) {
            case "download":
                this.baseService.downloadFile(fileResponse, fileObj.contentType, fileName, callback);
                break;
            case "print":
                this.baseService.printFile(fileResponse, fileObj.contentType,fileName, callback);
                break;
            case "view_file":
                this.baseService.viewFile(fileResponse, fileObj.contentType,fileName, callback);
                break;

            default:
                break;
        }
    }
    changelabelToHeading(labels) {
        var printbleHeaders = [];
        for (let key of labels) {
            if(key.label !='' && key.component !='action' && key.component !='link' && key.component !='button'){
                var obj = {
                    heading: key.label,
                    type: key.type,
                    name: key.name
                }
                printbleHeaders.push(obj)
            }
        }
        return printbleHeaders;
    }

}